import React, { useState } from "react";
import Utleieplan from "./Utleieplan";
import NewBookingModal from "./NewBookingModal";
import TodayLogistics from "./TodayLogistics";
import TomorrowLogistics from "./TomorrowLogistics";
import EquipmentList from "./EquipmentList";
import Customers from "./Customers";
import { Customer } from "../../types/types";

interface StrandAppProps {
  customers: Customer[];
  setCustomers: React.Dispatch<React.SetStateAction<Customer[]>>;
}

export default function StrandApp({ customers, setCustomers }: StrandAppProps) {
  const [tab, setTab] = useState("utleieplan");
  const [bookings, setBookings] = useState<any[]>([]);
  const [newBookingOpen, setNewBookingOpen] = useState(false);

  const handleSaveBooking = (newBooking: any) => {
    const fixedBooking = {
      ...newBooking,
      start: new Date(newBooking.start),
      end: new Date(newBooking.end),
    };
    setBookings([...bookings, fixedBooking]);
  };

  const handleAddCustomer = (newCustomer: any) => {
    // Convert to Customer type and add to shared customer list
    const customer: Customer = {
      id: Date.now(), // Temporary ID - should be handled by Supabase
      name: newCustomer.name,
      tlf: newCustomer.phone || '',
      epost: newCustomer.email || '',
      adresse: newCustomer.address || '',
      orgnr: newCustomer.orgNumber || '',
    };
    setCustomers([...customers, customer]);
  };

  // Convert Customer[] to format expected by Strand components
  const strandCustomers = customers.map(c => ({
    id: c.id,
    name: c.name,
    phone: c.tlf,
    email: c.epost,
    address: c.adresse,
    orgNumber: c.orgnr,
  }));

  return (
    <div className="min-h-screen bg-gray-200">
      {/* Navigation Tabs */}
      <nav className="bg-[#16437A]">
        <div className="max-w-7xl mx-auto px-4 flex space-x-4">
          {[
            { id: "utleieplan", label: "Utleieplan" },
            { id: "oversikt", label: "Utstyrsoversikt" },
            { id: "fakturering", label: "Fakturering" },
            { id: "historikk", label: "Historikk" },
            { id: "fakturaHistorikk", label: "Faktura historikk" },
            { id: "kunder", label: "Kunder" },
            { id: "notater", label: "Notater" },
          ].map((t) => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              className={`py-3 px-4 text-sm font-medium transition-all duration-200 rounded-t ${
                tab === t.id
                  ? "bg-white text-[#1B4E8C] font-bold shadow"
                  : "text-white hover:bg-[#1B4E8C] hover:text-white"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </nav>

      {/* MAIN CONTENT */}
      <main className="p-6 max-w-7xl mx-auto space-y-6">
        {tab === "utleieplan" && (
          <>
            {/* Today and Tomorrow Logistics */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white rounded shadow p-6 border border-gray-300">
                <h2 className="text-xl font-bold text-[#1B4E8C] mb-4">
                  Dagens Leveringer & Hentinger
                </h2>
                <TodayLogistics bookings={bookings} />
              </div>

              <div className="bg-white rounded shadow p-6 border border-gray-300">
                <TomorrowLogistics bookings={bookings} />
              </div>
            </div>

            {/* Calendar */}
            <div className="bg-gradient-to-br from-gray-50 via-white to-gray-50 border border-gray-300 rounded shadow p-6 mt-6">
              <Utleieplan
                bookings={bookings}
                openNewBooking={() => setNewBookingOpen(true)}
                onEditBooking={(booking) => {
                  // TODO: Implement edit booking
                  console.log('Edit booking:', booking);
                }}
                onCloseRental={(booking) => {
                  // TODO: Implement close rental
                  console.log('Close rental:', booking);
                }}
              />
              <NewBookingModal
                isOpen={newBookingOpen}
                onClose={() => setNewBookingOpen(false)}
                onSave={handleSaveBooking}
                customers={strandCustomers}
                onAddCustomer={handleAddCustomer}
              />
            </div>
          </>
        )}

        {tab === "oversikt" && (
          <div className="bg-white rounded shadow p-6 border border-gray-300">
            <EquipmentList />
          </div>
        )}

        {tab === "kunder" && (
          <div className="bg-white rounded shadow p-6 border border-gray-300">
            <Customers customers={strandCustomers} />
          </div>
        )}

        {tab === "fakturering" && (
          <div className="bg-white rounded shadow p-6 border border-gray-300">
            <h2 className="text-2xl font-bold text-[#1B4E8C] mb-4">Fakturering</h2>
            <p className="text-gray-600">Fakturering kommer her…</p>
          </div>
        )}

        {tab === "historikk" && (
          <div className="bg-white rounded shadow p-6 border border-gray-300">
            <h2 className="text-2xl font-bold text-[#1B4E8C] mb-4">Historikk</h2>
            <p className="text-gray-600">Historikk kommer her…</p>
          </div>
        )}

        {tab === "fakturaHistorikk" && (
          <div className="bg-white rounded shadow p-6 border border-gray-300">
            <h2 className="text-2xl font-bold text-[#1B4E8C] mb-4">Faktura historikk</h2>
            <p className="text-gray-600">Faktura historikk kommer her…</p>
          </div>
        )}

        {tab === "notater" && (
          <div className="bg-white rounded shadow p-6 border border-gray-300">
            <h2 className="text-2xl font-bold text-[#1B4E8C] mb-4">Notater</h2>
            <p className="text-gray-600">Notater kommer her…</p>
          </div>
        )}
      </main>
    </div>
  );
}
